module.exports = __webpack_public_path__ + "img/3.cd3f9958.jpg";